import React, { HTMLProps } from 'react';

export function IndeterminateCheckbox({
  indeterminate,
  className = '',
  ...rest
}: // eslint-disable-next-line react/require-default-props
{ indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return <input type="checkbox" ref={ref} className={`${className} cursor-pointer`} {...rest} />;
}
